"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLanguages = exports.getLanguageCodes = exports.getDefaultLanguage = exports.getCurrentLanguage = exports.getLocaleState = void 0;

var _constants = require("./constants");

/**
 * @description
 * Returns the appropriate part of the state.
 *
 * @param state             {Immutable.Map} - State where to select the local part.
 *
 */
var getLocaleState = function getLocaleState(appState) {
  return appState.get ? appState.get(_constants.STATE_KEY_NAME) : appState[_constants.STATE_KEY_NAME];
};
/**
 * @description
 * Returns the currently used language.
 *
 * @param localeState - the locale state from the reducer
 * @returns {string}
 */


exports.getLocaleState = getLocaleState;

var getCurrentLanguage = function getCurrentLanguage(localeState) {
  return localeState.language;
};
/**
 * @description
 * Returns the first language set by setting the language order
 * @param localeState
 * @returns {string}
 */


exports.getCurrentLanguage = getCurrentLanguage;

var getDefaultLanguage = function getDefaultLanguage(localeState) {
  return localeState.languageOrder[0];
};

exports.getDefaultLanguage = getDefaultLanguage;

var getLanguageCodes = function getLanguageCodes(localeState) {
  return localeState.languageOrder;
};
/**
 * @description
 * returns the array of languages used by react-intl.
 * @param localeState
 * @returns {Array}
 */


exports.getLanguageCodes = getLanguageCodes;

var getLanguages = function getLanguages(localeState) {
  var orderedKeys = localeState.languageOrder;
  return orderedKeys.reduce(function (returnVal, key) {
    if (localeState.messages[key]) {
      returnVal.push({
        id: key,
        name: localeState.messages[key].languageName,
        messages: localeState.messages[key]
      });
    }

    return returnVal;
  }, []);
};

exports.getLanguages = getLanguages;
//# sourceMappingURL=selectors.js.map